<div class="mainclass">
    <!-- Barra "Voltar para a grade" apenas quando usando TemplateDetailComponent (inclusão via template) -->
    <div class="datagrid-toolbar toolbar-edit-mode" *ngIf="(editing | async) && isTemplateMode">
        <button nz-button nzType="text" (click)="editing.next(false)" nz-tooltip="Voltar para a grade">
            <nz-icon nzType="enter"></nz-icon>
        </button>
        <span class="toolbar-edit-label">Voltar para a grade</span>
    </div>
    <div class="datagrid-toolbar" *ngIf="!(editing | async)">
            <div [hidden]="editing | async">
                <ng-container [ngSwitch]="showIcon" >
                    <button *ngSwitchCase="true" nz-button nzType="primary" nzShape="circle" [disabled]="!canInsert" (click)="adicionarLine($event)" [nz-tooltip]="'simpledatagrid.addnew'|translateTA">
                        <nz-icon nzType="plus"></nz-icon>
                    </button>
                    <button *ngSwitchCase="false" nz-button nzType="primary" (click)="adicionarLine($event)" [disabled]="!canInsert">{{'simpledatagrid.addnew'|translateTA}}</button>
                </ng-container>
            </div>
            <span class="span1"></span>
            <div [hidden]="editing | async">
                <ng-container [ngSwitch]="showIcon">
                    <button *ngSwitchCase="true" nz-button nzType="primary" nzDanger nzShape="circle" [disabled]="!canDelete" (click)="removeLine($event)" [nz-tooltip]="'remove'|translateTA">
                        <nz-icon nzType="delete"></nz-icon>
                    </button>
                    <button *ngSwitchCase="false" nz-button nzType="primary" nzDanger (click)="removeLine($event)" [disabled]="!canDelete" [nz-tooltip]="'remove'|translateTA">{{'simpledatagrid.remove'|translateTA}}</button>
                </ng-container>
            </div>
            <span class="span1"></span>
            <div [hidden]="editing | async">
                <ng-container [ngSwitch]="showIcon" >
                    <button *ngSwitchCase="true" nz-button nzType="primary" nzShape="circle" [disabled]="!canEdit" (click)="editLine($event)" [nz-tooltip]="'edit'|translateTA">
                        <nz-icon nzType="edit"></nz-icon>
                    </button>
                    <button *ngSwitchCase="false" nz-button nzType="primary" (click)="editLine($event)" [disabled]="!canInsert" [nz-tooltip]="'edit'|translateTA">{{'simpledatagrid.edit'|translateTA}}</button>
                </ng-container>
            </div>
            <span class="span1"></span>
            <div [hidden]="!showGetFrom">
                <div [hidden]="(editing | async)">
                    <button nz-button nzType="primary" nzShape="circle" (click)="getFrom($event,false)">
                        <nz-icon nzType="rollback"></nz-icon>
                    </button>
                </div>
            </div>
            <span class="span1"></span>
            <div [hidden]="!showGetFromComplex">
                <div [hidden]="(editing | async)">
                    <button nz-button nzType="primary" nzShape="circle" (click)="getFrom($event,true)">
                        <nz-icon nzType="rollback"></nz-icon>
                    </button>
                </div>
            </div>
            <span class="span1"></span>
            <div [hidden]="!canConfig">
                <div [hidden]="(editing | async)">
                    <button nz-button nzType="primary" nzShape="circle" (click)="openConfig($event)">
                        <nz-icon nzType="tool"></nz-icon>
                    </button>
                </div>
            </div>

            <button nz-button nzType="text" [hidden]="!(editing | async)" (click)="editing.next(false)">
                <nz-icon nzType="enter"></nz-icon>
            </button>
            <span class="span2"></span>
            <div class="atualizar-switch" [hidden]="(editing | async) || compact">
                <nz-switch [(ngModel)]="autoRefresh" nzSize="small"></nz-switch>
                <p class="atualizar">{{'refresh'|translateTA}}</p>
            </div>
            <div [hidden]="editing | async" class="div1">
                <nz-select class="filter-select" [formControl]="filterSelect" nzMode="multiple" [nzPlaceHolder]="'filter'|translateTA" [nzOpen]="filterPanelOpen" (nzOpenChange)="filterPanelOpen = $event" [compareWith]="compareFilter">
                    <nz-option *ngFor="let line of filter" [nzValue]="line" [nzLabel]="line.name" nzCustomContent>
                        <div class="item-filter" (mouseover)="showDel=true" (mouseout)="showDel=false">
                            <div [ngClass]="{'name':!showDel,'name-reduce':showDel}">{{line.name}}</div>
                            <div class="space"></div>
                            <div class="editicons">
                                <nz-icon id="editar" nzType="edit" [ngClass]="{'mouseOver':showDel, 'mouseOut':!showDel }" (click)="editFilter($event,line)"></nz-icon>
                                <nz-icon id="excluir" nzType="close" [ngClass]="{'mouseOver':showDel, 'mouseOut':!showDel }" (click)="removeFilter($event,line)"></nz-icon>
                            </div>
                        </div>
                    </nz-option>
                </nz-select>
            </div>
            <span class="span1"></span>
            <div [hidden]="editing | async">
                <button nz-button nzType="primary" nzShape="circle" [nz-tooltip]="'simpledatagrid.tooltip1'|translateTA" (click)="openFilter()">
                    <nz-icon nzType="filter"></nz-icon>
                </button>
            </div>
            <span class="span1"></span>
            <div [hidden]="editing | async">
                <ng-container [ngSwitch]="showIcon">
                    <button *ngSwitchCase="true" nz-button nzType="primary" nzShape="circle" (click)="apply(false,0)" [nz-tooltip]="'refresh'|translateTA">
                        <nz-icon nzType="reload"></nz-icon>
                    </button>
                    <button *ngSwitchCase="false" nz-button nzType="primary" (click)="apply(false,0)" [nz-tooltip]="'refresh'|translateTA">{{'simpledatagrid.refresh'|translateTA}}</button>
                </ng-container>
            </div>
            <span class="span1"></span>
            <div [hidden]="editing | async">
                <ng-container [ngSwitch]="showIcon" *ngIf="showAction" >
                    <button *ngSwitchCase="true" nz-button nzType="primary" nzShape="circle" nz-dropdown [nzDropdownMenu]="menuAcoes" [nz-tooltip]="'otheractions'|translateTA">
                        <nz-icon nzType="more"></nz-icon>
                    </button>
                    <button *ngSwitchCase="false" nz-button nzType="primary" nz-dropdown [nzDropdownMenu]="menuAcoes" [nz-tooltip]="'otheractions'|translateTA">{{'simpledatagrid.action'|translateTA}}</button>
                    <nz-dropdown-menu #menuAcoes="nzDropdownMenu">
                        <ul nz-menu>
                            <li nz-menu-item *ngFor="let mainItem of actionList" (click)="callCustomAction(mainItem,$event)">
                                <generic-icon [iconName]="mainItem.ICON" type="google"></generic-icon>
                                <span class="menu-label">{{'ACTION_'+mainItem.IDACTION|translateTA}}</span>
                            </li>
                        </ul>
                    </nz-dropdown-menu>
                </ng-container>
            </div>
            <span class="spacer"></span>
            <ng-container>
                <button nz-button nzType="primary" nzShape="circle" nz-dropdown [nzDropdownMenu]="menuMore" [nz-tooltip]="'tools'|translateTA">
                    <nz-icon nzType="tool"></nz-icon>
                </button>
                <nz-dropdown-menu #menuMore="nzDropdownMenu">
                    <ul nz-menu>
                        <li nz-menu-item *ngIf="canExport" [hidden]="editing | async" (click)="exportExcel()">
                            <generic-icon iconName="excel" type="custom"></generic-icon>
                            <span class="menu-label">{{'simpledatagrid.exportexcel'|translateTA}}</span>
                        </li>
                        <li nz-menu-divider *ngIf="canExport" [hidden]="editing | async"></li>
                        <li nz-menu-item [hidden]="(editing | async) || !canConfig" (click)="openGridColorConfig()">
                            <nz-icon nzType="bg-colors"></nz-icon>
                            <span class="menu-label">{{'simpledatagrid.colorlines'|translateTA}}</span>
                        </li>
                        <li nz-menu-item [hidden]="editing | async" (click)="expandFields()">
                            <nz-icon nzType="drag"></nz-icon>
                            <span class="menu-label">{{'simpledatagrid.columnsdist'|translateTA}}</span>
                        </li>
                        <li nz-menu-item [hidden]="editing | async" (click)="openGridDialogConfig()">
                            <nz-icon nzType="table"></nz-icon>
                            <span class="menu-label">{{'simpledatagrid.columnselect'|translateTA}}</span>
                        </li>
                        <li nz-menu-item *ngIf="hasLog" [hidden]="editing | async" (click)="openLog()">
                            <nz-icon nzType="history"></nz-icon>
                            <span class="menu-label">{{'simpledatagrid.showlog'|translateTA}}</span>
                        </li>
                    </ul>
                </nz-dropdown-menu>
            </ng-container>
    </div>

    <div class="main-content" [hidden]="editing | async" >
        <div [hidden]="editing | async" class="floating-loading">
            <div class="summary">
              <!--div class="totalLines">Total de Linhas: {{ totalLines }}</div>
              <span class="spacer"></span-->
              <div class="alert-message" *ngIf="showLimitLinesError"><nz-icon nzType="warning" class="blinker"></nz-icon> <span class="message">{{'simpledatagrid.limitlines'|translateTA}}</span></div>
              <div class="paginator-container">
                <div class="paginator" *ngIf="showPaginator">
                    <div class="info">{{'simpledatagrid.loadreg'|translateTA}} {{rowLength }} de {{ totalLines }} |</div>
                    <div class="cancelar" (click)="cancelLoading()">Cancelar</div>
                </div>
              </div>
              <!--span class="spacer"></span>
              <div class="lines" *ngIf="!showPaginator">Linhas: {{ rowLength }} </div-->
            </div>
        </div>
        <div class="simpletable">
            <nz-spin class="grid-spin" [nzSpinning]="gridLoading" [nzTip]="gridLoadingTip || 'Carregando...'" nzSize="large">
            <ag-grid-angular *ngIf="gridActivated"
                style="width: 100%; height: 100%"
                [class]="(ThemeService.theme)? 'ag-theme-quartz-dark':'ag-theme-quartz'"
                (rowSelected)="selectedData($event)"
                [rowData]="rows"
                [columnDefs]="displayedColumns"
                [columnTypes]="columnTypes"
                (rowDoubleClicked)="eventGrid($event)"
                (rowClicked)="eventGridSelect($event)"
                (columnResized)="onResize($event)"
                (gridReady)="onGridReady($event)"
                enableCellExpressions="true"
                [localeText]="ls.getCurrentGridLocale()"
                [overlayNoRowsTemplate]="'simpledatagrid.norows'|translateTA"
                rowBuffer="150"
                rowSelection="multiple"
                cacheBlockSize= "100"
                cacheOverflowSize="2"
                maxBlocksInCache= 10
                [copyHeadersToClipboard]="true"
                (sortChanged)="sortChanged($event)"
                [multiSortKey]="true"
                [pagination]="showPagination"
                [enableCellTextSelection]="true"
                [suppressClipboardPaste]="true"

            >
            </ag-grid-angular>
            </nz-spin>

    </div>

</div>

<div class="main-content-edit" *ngIf="(editing | async)  && componentedit == undefined">
    <editform
      [parentRow]="parentRow"
      [entityName]="entityName"
      [entityDesc]="entityDesc"
      [row]="row"
      [filter]="filter"
      [userConfig]="userConfig"
      [tableInformation]="tableInformation"
      [formViewColumns]="formViewColumns"
      [formGroup]="formGroup"
      [evento]="evento"
      [forceParentRow]="forceParentRow"
      [$$REFERENCES]="$$REFERENCES"
      [actionList]="actionList"
      (saving)="savingForm($event)"
      [canConfig]="canConfig"
      [dataMultiTableConfig]="dataMultiTableConfig"
      [customComponents]="customComponents"
      [customFields]="customFields"
      [customFunction]="customFunction">
    </editform>
  </div>

  <div class="main-content-edit" *ngIf="(editing | async)  && componentedit != undefined">
      <ng-template #editContainer></ng-template>
  </div>
